import React from 'react';
import { Trophy, Star, TrendingUp } from 'lucide-react';

const TopPerformersTable = ({ data, type, title }) => {
  const getTypeIcon = () => {
    switch(type) {
      case 'song': return <Star className="w-5 h-5 text-yellow-500" />;
      case 'role': return <Trophy className="w-5 h-5 text-purple-500" />;
      case 'musical': return <TrendingUp className="w-5 h-5 text-blue-500" />;
      default: return null;
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-md">
      <div className="flex items-center gap-3 mb-6">
        {getTypeIcon()}
        <h3 className="text-xl font-bold text-gray-900">{title}</h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Rank</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Title</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Musical</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">CTR</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">Completion</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">Favorites</th>
              <th className="text-right py-3 px-4 text-sm font-semibold text-gray-700">Confidence</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr 
                key={item?.contentId} 
                className="border-b border-gray-100 hover:bg-gray-50 transition-colors"
              >
                <td className="py-4 px-4">
                  <div className="flex items-center gap-2">
                    <span className={`font-bold ${
                      index === 0 ? 'text-yellow-500' :
                      index === 1 ? 'text-gray-400' :
                      index === 2 ? 'text-orange-400': 'text-gray-500'
                    }`}>
                      #{index + 1}
                    </span>
                  </div>
                </td>
                <td className="py-4 px-4">
                  <span className="font-medium text-gray-900">{item?.title}</span>
                </td>
                <td className="py-4 px-4">
                  <span className="text-sm text-gray-600">{item?.musicalTitle || '-'}</span>
                </td>
                <td className="py-4 px-4 text-right">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                    {item?.clickThroughRate?.toFixed(1) || 0}%
                  </span>
                </td>
                <td className="py-4 px-4 text-right">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    {item?.completionRate?.toFixed(1) || 0}%
                  </span>
                </td>
                <td className="py-4 px-4 text-right">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                    {item?.favoriteRate?.toFixed(1) || 0}%
                  </span>
                </td>
                <td className="py-4 px-4 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <div className="w-16 bg-gray-200 rounded-full h-2">
                      <div 
                        className="bg-gradient-to-r from-purple-600 to-purple-400 h-2 rounded-full" 
                        style={{ width: `${(item?.avgConfidence || 0) * 100}%` }}
                      />
                    </div>
                    <span className="text-sm text-gray-600 w-12 text-right">
                      {((item?.avgConfidence || 0) * 100)?.toFixed(0)}%
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {(!data || data?.length === 0) && (
        <div className="text-center py-12">
          <p className="text-gray-500">No performance data available yet</p>
        </div>
      )}
    </div>
  );
};

export default TopPerformersTable;